import { IAssessment } from "./main.interfaces";

export interface IAllAssessmentsResponse {
  _embedded: {
    assessmentList: IAssessment[];
    _links: {
      self: {
        href: string;
      };
    };
  };
}
export enum BackendRestAPIRequestTypes {
  GET = "GET",
  POST = "POST",
  PUT = "PUT",
  DELETE = "DELETE"
}

/**
 * Creates a header-object containing information about the Content-Type and Authorization.
 */
export function createRequestHeader(
  authorization?: string,
  requestBody?: any
): Headers {
  const headers = new Headers();
  if (requestBody != null) {
    headers.append("Content-Type", "application/json");
  }
  headers.append("Accept", "application/json");
  headers.append("X-Requested-With", "XMLHttpRequest");
  if (authorization) {
    headers.append("Authorization", authorization);
  }
  const xsrfCookie = getCookieByName("XSRF-TOKEN");
  if (xsrfCookie) {
    headers.append("X-XSRF-TOKEN", xsrfCookie);
  }
  return headers;
}

/**
 * Returns the value of a cookie for a given cookie name.
 * @param name
 */
function getCookieByName(name: string) {
  name = name + "=";
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

/**
 * Creates a RequestInit-object used for Rest-calls.
 * @param requestType The type of the request. Possible values in BackendRestApiRequestTypes
 * @param requestBody Optional content of the request with data to be transmitted.
 */
export function createRequestOptions(
  requestType: BackendRestAPIRequestTypes,
  requestBody?: any,
  customAuthorization?: string
): RequestInit {
  let requestObject: {} | undefined = undefined;

  const requestOptions: RequestInit = {
    method: requestType,
    headers: createRequestHeader(customAuthorization, requestBody),
    body: requestBody != null ? JSON.stringify(requestBody) : undefined
  };
  return requestOptions;
}
